module.exports = __webpack_public_path__ + "img/pilpel_no.912bafe4.png";